const checkResult = (lang: string, allLanguages: Array<string>): string | undefined => {
  let res: string | undefined
  // Lang can be 2-chars
  if (lang.length === 2) {
    res = allLanguages.find((language) => {
      return language.split('-')[0]?.toLowerCase() === lang.toLowerCase()
    })
  } else {
    res = allLanguages.find((language) => {
      return language.toLowerCase() === lang.toLowerCase()
    })

    if (!res) {
      res = allLanguages.find((language) => {
        return language.startsWith(`${lang.split('-')[0].toLowerCase()}-`)
      })
    }
  }

  return res
}

// Check if the locale in the current browser is in the array of available locales
const checkLocaleFromBrowser = (allLanguages: string[]): string | undefined => {
  const navLang = navigator?.language
  if (navLang && allLanguages?.length) {
    return checkResult(navLang, allLanguages)
  }

  return undefined
}

export const checkLocale = (languageData, localeConfig): string => {
  // Use browser locale if config doesn't prevent it
  if (localeConfig?.getDefaultFromBrowser !== false) {
    const browserLocale: string | undefined = checkLocaleFromBrowser(languageData.all)
    if (browserLocale) return browserLocale
  }

  // Else check the "lang" tag in the html element
  const htmlElements = document.getElementsByTagName('html')
  if (htmlElements.length && htmlElements[0].lang) {
    const htmlLocale = checkResult(htmlElements[0].lang, languageData.all)
    if (htmlLocale) return htmlLocale
  }

  // Else, use default from languageData
  return languageData.default
}

export const getMainLocale = (locale: string): string => {
  const split = locale.split('-')
  return split.length ? split[1] : split[0]
}
